import React, { useEffect, useState } from "react";
import "../styles/public.css";
import axios from "../axios";
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";

// 👉 compteur global pour détecter les nouveaux produits sans socket
let lastPublicCount = 0;

const PublicProductsPage = () => {
  const [grouped, setGrouped] = useState({});
  const [toast, setToast] = useState(false);

  const fetchProducts = async (notifyOnNew = false) => {
    try {
      const res = await axios.get("/products/public");

      // Regroupe par vendeur
      const groups = res.data.reduce((acc, prod) => {
        const vendor = prod.ownerName || "Inconnu";
        if (!acc[vendor]) acc[vendor] = [];
        acc[vendor].push(prod);
        return acc;
      }, {});

      setGrouped(groups);

      // 👉 Détecter les suppressions : si un produit existait avant mais plus maintenant
      const previousVendors = Object.keys(grouped);
      previousVendors.forEach(vendor => {
        const oldList = grouped[vendor] || [];
        const newList = groups[vendor] || [];

        // produit supprimé = présent avant, absent maintenant
        const removed = oldList.filter(
          oldProd => !newList.some(newProd => newProd.productId === oldProd.productId)
        );

        if (removed.length > 0) {
          console.log("🗑️ Produits supprimés détectés côté vitrine :", removed);
        }
      });

      
      const total = res.data.length;

      // 👉 Si on a plus de produits qu'avant, on affiche un toast “nouveaux produits”
      if (notifyOnNew && total > lastPublicCount) {
        setToast(true);
        setTimeout(() => setToast(false), 5000);
      }

      lastPublicCount = total;
    } catch (err) {
      console.error("Erreur récupération produits publics :", err);
    }
  };

  useEffect(() => {
    // 1) Chargement initial, sans notification
    fetchProducts(false);

    // 2) Toutes les 2 minutes, on re-check si des produits ont été ajoutés
    const interval = setInterval(() => {
      fetchProducts(true);
    }, 120000); // 120 000 ms = 2 minutes

    return () => clearInterval(interval);
  }, []);

  console.log("✅ Nouvelle version PublicProductsPage déployée (timer)");

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-10">
      {/* 🔥 TOAST VISUEL “Nouveaux produits” */}
      {toast && (
        <div className="cn-toast">
          🆕 Nouveau(x) produit(s) ajouté(s) !
        </div>
      )}

      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-blue-600">🛒 Produits Disponibles</h1>
        <Link
          to="/"
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
        >
          ⬅️ Retour à l’accueil
        </Link>
      </div>

      {/* Parcours des vendeurs */}
      {Object.keys(grouped).map((vendor) => (
        <div key={vendor} className="bg-white shadow rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Vendeur : {vendor}
          </h2>

          <div className="products-grid">
            {grouped[vendor].map((prod) => (
              <div key={prod.productId} className="product-card relative">
                <h3 className="text-lg font-bold mb-2 text-gray-900 text-center">
                  {prod.articleName}
                </h3>
                <p className="text-gray-700 text-sm mb-2">
                  Statut : {prod.status}
                </p>

                <QRCodeCanvas
                  value={`${window.location.origin}/product/${prod.productId}?fromQR=true`}
                  size={100}
                  className="mb-3"
                />

                <button
                  onClick={() =>
                    (window.location.href = `/product/${prod.productId}`)
                  }
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
                >
                  Voir le produit
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PublicProductsPage;
